module.exports = __webpack_public_path__ + "static/media/giant-gourami.27db51f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/giant-gourami.png
// module id = 313
// module chunks = 0